import { styled, Box } from "@mui/material";

export const StyledTopNavContainer = styled(Box)({
  position: "sticky",
  top: 0,
  width: "100%",
  zIndex: 10,
});
